import styled from "styled-components";

export const StyledConfirm = styled.div`
  .title {
    padding: 1.6rem;
    width: calc(56rem - 3.2rem);
    min-height: calc(24.8rem - 3.2rem);
    font: var(--body-large-400);
    color: var(--text-gray-strong);
    text-align: center;
    white-space: pre-line;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
  }

  .footer-wrap {
    padding: 1.2rem;
    display: flex;
    flex-flow: row nowrap;
    gap: 0.8rem;
    justify-content: end;
  }
`;
